export default __webpack_public_path__ + "static/media/question-bank.6e83e08f.svg";